export default __webpack_public_path__ + "static/media/galazy.a4d2625a.png";